import useDropdownMenu from 'react-accessible-dropdown-menu-hook';

export const usePatchedDropdownMenu = (menuItemsAmount: number) => {
    const result = useDropdownMenu(menuItemsAmount);
    const { buttonProps } = result;
    const { itemProps } = result;

    // Presence of `tabIndex` attribute for <a> node in Safari makes that element
    // appear with system styling that corresponds to 'focus' event
    delete buttonProps.tabIndex;
    itemProps.forEach((item: { tabIndex?: number }) => delete item.tabIndex);

    return result as any; // Should be fixed in ZXY-625
};
